'use client';

import { c as _c } from "react/compiler-runtime";
import Grid from '@mui/material/Grid';
import Footnotes from 'src/app/credit-cards/reviews/components/Body/WordpressSections/Footnotes';
import ReviewAuthorsDetails from 'src/app/credit-cards/reviews/components/Footer/AuthorsDetails';
import ReviewFAQs from 'src/app/credit-cards/reviews/components/Footer/FAQs';
import Methodology from './Methodology';
export default function ReviewFooter() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Grid container={true}><Grid size={{
        xs: 12,
        md: 8
      }}><Footnotes /><Methodology /><ReviewFAQs /><ReviewAuthorsDetails /></Grid></Grid>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}